export const CHANGE_PASSWORD_PATH = 'weakPassword.changePasswordPath';
export const PARTNERS_URL = 'https://partners.rappi.com';
